export default {
    ERRORS: {
        GENERIC:
            'Något har gått fel på Tradera. Vi jobbar på att fixa det. Försök igen om en stund.',
    },
    SHIPPING_LABELS: {
        NO_SELECTED_SHIPPING: 'Inget fraktsätt valt',
        FREE_SHIPPING: 'Fri frakt',
        TAKEAWAY: 'Avhämtning',
    },
} as const;
